<template>
  <div class="pt-4 pl-4">
    <div v-if="canChangeCustomer">
      <v-list-item-subtitle>Select a customer</v-list-item-subtitle>
      <v-card-text>
        <v-autocomplete
          v-model="model"
          no-filter
          :items="entries"
          :loading="isLoading"
          :search-input.sync="search"
          chips
          hide-details
          hide-selected
          item-text="displayName"
          item-value="id"
          label="Search for a customer..."
          return-object
          solo>
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="blue-grey"
              class="white--text"
              v-on="on">
              <v-icon left>
                mdi-account
              </v-icon>
              <span v-text="item.displayName" class="pr-2"></span>
              <span v-text="item.mobileNumber"></span>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              color="indigo"
              class="headline font-weight-light white--text">
              {{ item.lastName.charAt(0) }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.displayName"></v-list-item-title>
              <v-list-item-subtitle v-text="item.mobileNumber"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
          </template>
          <template v-slot:append>
            <v-btn icon color="primary" v-on:click="clearCustomer">
              <v-icon>mdi-eraser</v-icon>
            </v-btn>
          </template>
        </v-autocomplete>
        <v-checkbox v-model="updateCustomerDetails" :label="`Update Customer Details`"></v-checkbox>
      </v-card-text>
    </div>
    <div v-if="!canChangeCustomer">
      <v-list-item-subtitle>Selected customer</v-list-item-subtitle>
      <v-card-text>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              color="green"
              class="white--text"
              v-bind="attrs"
              v-on="on">
              <v-icon left>
                mdi-account
              </v-icon>
              <span v-text="firstName + ' ' + lastName" class="pr-2"></span>
              <span v-text="mobileNumber"></span>
            </v-chip>
          </template>
        </v-tooltip>
      </v-card-text>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'CustomerSearch',
  components: { },
  props: {
    bus: Vue,
    getFlightsOnSelection: {
      type: Boolean,
      default: false,
    },
    canChangeCustomer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    count: null,
  }),
  created() {
    this.bus.$on(storeConstants.EVT_NEW_CUSTOMER_BOOKING, (customer) => {
      this.entries = [customer.data];
      this.model = customer.data;
    });
  },
  methods: {
    ...mapActions([
      storeConstants.SEARCH_CUSTOMERS,
      storeConstants.GET_FLIGHTS]),
    getFlights(isReturnTrip) {
      const retrieveFlights = (tempDirection) => {
        const payload = { direction: tempDirection, suburb: this.suburb };
        this.GET_FLIGHTS(payload)
          .then((flights) => {
            if (tempDirection === 1) {
              this.$store.commit(storeConstants.SET_DEPARTING_FLIGHTS, flights);
            } else {
              this.$store.commit(storeConstants.SET_ARRIVING_FLIGHTS, flights);
            }
          });
      };
      if (isReturnTrip) {
        retrieveFlights(1);
        retrieveFlights(2);
      } else {
        retrieveFlights(this.direction);
      }
    },
    clearCustomer() {
      this.$store.commit(storeConstants.RESET_CUSTOMER);
      this.$store.commit(storeConstants.RESET_SELECTED_ADDRESS);
      this.entries = [];
    },
    fetchEntriesDebounced(val) {
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.fetchEntries(val);
      }, 1000);
    },
    fetchEntries(val) {
      this.SEARCH_CUSTOMERS({ searchText: val })
        .then(() => {
          this.count = this.CUSTOMER_SEARCH_RESULTS.length;
          this.entries = this.CUSTOMER_SEARCH_RESULTS;
          this.isLoading = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters([storeConstants.CUSTOMER_SEARCH_RESULTS]),
    ...mapFields([
      'booking.direction',
      'booking.selectedAddress.suburb',
      'booking.updateCustomerDetails',
      'booking.firstName',
      'booking.lastName',
      'booking.mobileNumber',
    ]),
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map((key) => {
        const item = {
          key,
          value: this.model[key] || 'n/a',
        };
        return item;
      });
    },
  },
  watch: {
    model(val) {
      if (val) {
        this.$store.commit(storeConstants.SET_CUSTOMER, val);
        this.getFlights(this.direction === 3);
      } else {
        this.$store.commit(storeConstants.RESET_CUSTOMER);
      }
    },
    search(val) {
      // search text is valid
      if (!val || val.length < 4) return;

      this.fetchEntriesDebounced(val);
    },
  },
};
</script>
<style scoped>
.v-card__text .row .col {
  padding: 0.5rem;
}
</style>
